//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, View, SafeAreaView, Platform, useWindowDimensions, FlatList, TouchableOpacity, Pressable, Switch } from 'react-native';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../styles/commonStyles';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import CustomButton from '../../../components/CustomButton';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import TeacherPeriods from './TeacherPeriods';
import { ActivityIndicator, Card, Checkbox } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import { useTimeSheets } from '../../../hooks/useTimeSheets';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useCompany } from '../../../hooks/useCompany';
import { useTableHelper } from '../../../hooks/useTableHelper';
import { useSettings } from '../../../hooks/useSettings';
var _ = require('lodash');
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { exportToWord } from '../../../FileSave/Word/fileSaverWord';

//#endregion

const FlatListView = React.memo(({ item, index, props, styles, handleEditPress, duplicates,
    handleDelete, t, years, handlePress, showChildren, getLimitedLocationData, toggleSubmit, toggleApprove, downloadTimeSheetExcel, itemCount, branches, colors }) => {
    const [showAdditionalInformation, setShowAdditionalInformation] = useState(false);
    const [locations, setLocations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const prevBranch = useRef('');

    let errorMark = false;
    let errorAttr = '';
    // * To get Location Description based on Item.location
    function getLabelByValue(value) {
        const obj = locations.find(item => item.value === value);
        return obj ? obj.label : undefined;
    }


    duplicates.forEach(duplicate => {
        // * if empty and already had duplicated in other lines ignore empty lise
        if (item[duplicate.attribute] === '')
            errorMark = false;
        else if (duplicate.attrVal?.includes(item[duplicate.attribute])) {
            errorMark = true;
            errorAttr = duplicate.attribute;
        }
    });

    useEffect(() => {
        if (item.company !== '' && item.branch !== '' && !showChildren) {
            prevBranch.current = item.branch;
            setLocations([])
            setIsLoading(true);
            getLimitedLocationData(item.company, item.branch).then((resp) => {
                // * If the selected code for location does not exist in brancha change then clear the selection 
                if (!resp.some(obj => obj.value === item.location)) {
                    handleEditPress(index, item, 'location', '')
                }
                setLocations(resp)
                setIsLoading(false);
            }).catch((err) => { console.log(err); setIsLoading(false); })
        }
    }, [item.branch])

    useEffect(() => {
        //TODO
    }, [showAdditionalInformation])

    const onShowAdditionalLocationInfoPress = (item) => {
        setShowAdditionalInformation(!showAdditionalInformation)
    }
    // * For enabling/disabling CustomInputs
    let isEditable = true;
    if (item.approved || props.isApproval) {
        isEditable = false;
    }

    if (showChildren)
        return (
            <SafeAreaView
                style={[{ flex: 1, alignContent: 'center' }]}>
                <CustomLabel
                    value={item?.name === "" ? item?.timesheetUI : item?.name}
                    type="AVAILABLEUSED_SECONDARY" />

            </SafeAreaView>
        )

    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        );
    return (

        <SafeAreaView style={styles.column}>
            <SafeAreaView
                style={styles.row}>

                {/* //* Always Visible */}
                <SafeAreaView
                    style={styles.column}>
                    <CustomInput
                        value={item?.name}
                        editable={isEditable}
                        selectall={isEditable}
                        setValue={(e) => handleEditPress(index, item, 'name', e)}
                        maxLen={255}
                        type={errorMark && errorAttr == 'name' ? "MISSING_LOCATIONS_CODE" : "MAININPUT"}
                    />
                </SafeAreaView>
                <SafeAreaView
                    style={styles.column}>
                    <CustomDropDown
                        options={props.approvers}
                        disabled={item.approved || props.isApproval}
                        defValue={item.approverID}
                        value={item.approverID}
                        setValue={(e) => handleEditPress(index, item, 'approverID', e)}
                        type='FULL'
                    />
                </SafeAreaView>
                {/* //! company is only 1 for pascal so removing now. In the future we will connect with company selector in HR  */}
                {/* <SafeAreaView
                            style={styles.column}>
                            <CustomLabel
                                value={t('common:company')}
                                type='SUBTITLENOFLEX' />

                            <CustomDropDown
                                options={props.companies}
                                disabled={item.approved || props.isApproval}
                                defValue={item.company}
                                value={item.company}
                                setValue={(e) => handleEditPress(index, item, 'company', e)}
                                type='TIMESHEET'
                            />
                        </SafeAreaView> */}
                <SafeAreaView
                    style={styles.column}>

                    <CustomDropDown
                        options={branches}
                        disabled={item.company === '' || (item.approved || props.isApproval) ? true : false}
                        defValue={item.branch}
                        value={item.branch}
                        setValue={(e) => {
                            handleEditPress(index, item, 'branch', e)
                        }}
                        type='FULL'
                    />
                </SafeAreaView>
                <SafeAreaView
                    style={styles.column}>
                    <CustomDropDown
                        options={locations}
                        disabled={item.company === '' || item.branch === '' || (item.approved || props.isApproval) ? true : false}
                        defValue={item.location}
                        value={item.location}
                        setValue={(e) => {
                            handleEditPress(index, item, 'location', e)
                        }}
                        type='FULL'
                    />
                </SafeAreaView>
                <SafeAreaView
                    style={styles.column}>
                    <CustomDropDown
                        options={years}
                        disabled={item.approved || props.isApproval}
                        defValue={item.yr}
                        value={item.yr}
                        setValue={(value) => handleEditPress(index, item, 'yr', value)}
                        type='FULL'
                    />
                </SafeAreaView>
                <SafeAreaView>
                    <CustomButton
                        iconName={!showAdditionalInformation ? 'chevron-forward-outline' : 'chevron-down-outline'}
                        onPress={() => {
                            onShowAdditionalLocationInfoPress(item, index)
                        }}
                        text={t('common:showComments')}
                        show='PART'
                        type='PART'
                        textTop='0'
                        sz={30} />
                </SafeAreaView>
                <View style={styles.verticalLine} />
                {item?.childCount > 0 &&
                    <SafeAreaView>
                        <SafeAreaView style={styles.rowNoflex}>
                            <SafeAreaView style={styles.columnCheck}>
                                <Checkbox
                                    disabled={!item?.submitted}
                                    status={
                                        item?.approved ? "checked" : "unchecked"
                                    }
                                    onPress={() => toggleApprove(item.timesheetUI)}
                                />
                            </SafeAreaView>
                            <CustomLabel
                                value={t('common:approved')}
                                type='SUBTITLENOFLEX' />
                        </SafeAreaView>
                        <SafeAreaView style={styles.rowNoflex}>
                            <SafeAreaView style={styles.columnCheck}>
                                <Checkbox
                                    disabled={props.isApproval || item?.approved}
                                    status={
                                        item?.submitted ? "checked" : "unchecked"
                                    }
                                    onPress={() => toggleSubmit(item.timesheetUI)}
                                />
                            </SafeAreaView>
                            <CustomLabel
                                value={t('common:submitted')}
                                type='SUBTITLENOFLEX' />
                        </SafeAreaView>
                    </SafeAreaView>
                }
                <SafeAreaView style={styles.justMargin}>
                    {item.timesheetUI !== '' &&
                        <CustomButton
                            iconName='time-outline'
                            onPress={() => {
                                handlePress(item, index, getLabelByValue(item.location))
                            }}
                            show='HOME_BELL'
                            type='HOME_BELL'
                            textTop='2'
                            sz={30} />
                    }
                    {(item.submitted || props.isApproval) &&
                        <CustomButton
                            iconName='download-outline'
                            onPress={() => {
                                downloadTimeSheetExcel(item, branches)
                            }}
                            show='HOME_BELL'
                            type='HOME_BELL'
                            textTop='2'
                            sz={30} />
                    }

                    {(item?.childCount <= 0 && itemCount > 1) && <CustomButton
                        iconName='trash-outline'
                        onPress={() => {
                            handleDelete(item, index, 'timesheetUI')
                        }}
                        show='HOME_BELL'
                        type='HOME_BELL'
                        textTop='2'
                        sz={30} />
                    }
                </SafeAreaView>
            </SafeAreaView>

            {showAdditionalInformation &&
                <SafeAreaView style={[styles.row]}>
                    <SafeAreaView
                        style={styles.column}>
                        <CustomLabel
                            value={t('common:Comm')}
                            type='SUBTITLENOFLEX' />
                        <CustomInput
                            defaultValue={item.comments}
                            setValue={(e) => handleEditPress(index, item, 'comments', e)}
                            editable={isEditable}
                            maxLen={200}
                            multiline={true}
                            numberOfLines={5}
                            type="MAININPUT"
                        />
                    </SafeAreaView>

                </SafeAreaView>
            }
        </SafeAreaView>


    )
})

const TeacherTimeSheets = (props) => {
    //#region Const Definitions
    const { width, height } = useWindowDimensions();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const { account } = useAccountContext();
    const [timesheets, setTimeSheets] = useState([]);
    const [refreshAfterSave, setRefreshAfterSave] = useState(true);
    const [showEmployeePeriods, setShowEmployeePeriods] = useState(false);
    const [changesChildren, setChangesChildren] = useState([]);
    const [selectedItem, setSelectedItem] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');
    const [originalData, setOriginalData] = useState([]);
    const [changes, setChanges] = useState({})
    const [buttonStates, setButtonStates] = useState({});
    const [deletedItems, setDeletedItems] = useState([]);
    const [approveAll, setApproveAll] = useState(false);
    const [filterYear, setFilterYear] = useState(new Date().getFullYear().toString());
    const [showApproved, setShowApproved] = useState(true);
    const [years, setYears] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const { hasDuplicates, handleCancelChanges, rowAdd, rowDelete, rowEdit, areAllAttributesNullOrEmpty } = useTableHelper();
    const { getTimeSheets, saveTimesheets, deleteTimesheets, submitTimesheet, approveTimesheet, loadTeacherperiods, getAdditionalPeriodsWithTotals, isLoading } = useTimeSheets();
    const { getLimitedBranchData, getLimitedLocationData } = useCompany();
    const ref = useRef(null);
    const companyRef = useRef(null);

    const generateYears = () => {
        const currentYear = 2024;
        const years = [];
        for (let i = currentYear - 1; i <= currentYear + 20; i++) {
            years.push({ label: `${(i - 1).toString()} - ${i.toString()} `, value: i.toString() },);
        }
        setYears(years)
    };
    //#endregion

    // * Language
    const { t, i18n } = useTranslation();

    //#region UseEffect
    const load = async () => {
        getTimeSheets()
            .then((resp) => {
                if (resp[0].company === '')
                    resp[0].company = props.company.code
                generateYears();
                setTimeSheets(resp);
                setOriginalData(resp)
                setChanges({});
                setRefreshAfterSave(false);
            }).catch(() => {
                setRefreshAfterSave(false);
            })
    }
    useEffect(() => {
        if ((companyRef.current !== null) && companyRef.current !== props.selectedCompany) {
            props.handleGoBack();
            return;
        }
        if (refreshAfterSave) load().then(() => { }).catch(() => console.log('loading failed'))
    }, [refreshAfterSave])

    useEffect(() => {
        setBranches([])
        if (props.company) {
            console.log(props.company)
            getLimitedBranchData(props.company.code).then((resp) => {
                const branchesToRemove = ['HQ', 'F&B', 'BRD'];
                const filteredData = resp.filter(item => !branchesToRemove.includes(item.value.trim()));
                setBranches(filteredData)
            }).catch((err) => console.log(err))
        }
    }, [props.company])

    //#endregion

    //#region Helpers 
    // * To get Location Description based on Item.location
    function getLabelByValue(array, value) {
        let tot = 0;
        value.forEach(valItr => {
            const obj = array.find(item => item.additionalCode === valItr);
            tot += obj ? obj.periodDuration : 0;
        })
        return tot;
    }

    function getDescriptionByCode(array, value) {
        let description = '';
        value.forEach(valItr => {
            const obj = array.find(item => item.additionalCode === valItr);
            description += obj ? obj.additionalDesc + ', ' : '';
        })
        return description;
    }
    //#endregion 
    //#region Listeners
    // * Move to Submenu of selected line - Child Table in SQL one to many connection (i.e Branch/Loc - Salary Scheme/Components etc)
    const handlePress = async (item, index, location) => {
        if (Object.keys(changes).length > 0 || timesheets.some(obj => areAllAttributesNullOrEmpty(obj, ['yr', 'approverID', 'approver']))) {
            let ret = await showSwall();
            if (!ret.isConfirmed) {
                return
            }
            else {
                handleCancelChanges(setTimeSheets, originalData, setDeletedItems, setChanges, setDuplicates)
            }

        }
        if (!showEmployeePeriods) {
            setShowEmployeePeriods(!showEmployeePeriods)
        }
        //* Setting the id column - Not consident in all tables must change
        setSelectedItem(item);
        setSelectedLocation(location);
        setSelectedBranch(item?.branch);
        if (selectedItem === item?.timesheetUI && showEmployeePeriods)
            return;
        setButtonStates((prevState) => {
            const newState = Object.keys(prevState).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});
            newState[index] = !prevState[index];
            return newState;
        });
    }

    const showSwall = async () => {
        return Swal.fire({
            title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:changeBranchesMessage')}</text>`,
            icon: "warning",
            showCancelButton: true,
            reverseButtons: true,
            cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
            cancelButtonColor: '#d3d3d3',
            confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
            confirmButtonColor: '#A0A2FF',
        });
    }

    const handleGoBack = async () => {
        if (Object.keys(changesChildren).length > 0) {
            let ret = await showSwall();
            if (!ret.isConfirmed)
                return
        }
        if (showEmployeePeriods) {
            setShowEmployeePeriods(false);
            setButtonStates((prevState) => {
                const newState = Object.keys(prevState).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {});
                return newState;
            });
            setRefreshAfterSave(true);
        }
    }

    const handleEditPress = useCallback((idx, item, key, value) => {
        // * because we are loading branches on the fly we need to only call edit if branch value is different thatn the original value
        if (value === item[key])
            return;
        rowEdit(idx, item, key, value, changes, setChanges, timesheets, setTimeSheets)
    }, [])

    // * Submit / Unsubmit automatically saves and refreshes data
    const toggleSubmit = (timesheetUI) => {
        submitTimesheet(timesheetUI)
            .then((res) => {
                load().then(() => {
                    // * this only works if children are shown but there is no issue when there is not. 
                    handleGoBack()
                }).catch(() => console.log('loading failed'))
            })
            .catch(() => { })
    }

    const toggleApprove = (timesheetUI) => {
        approveTimesheet(timesheetUI)
            .then((res) => {
                load().then(() => {
                    // * this only works if children are shown but there is no issue when there is not. 
                    handleGoBack()
                }).catch(() => console.log('loading failed'))
            })
            .catch(() => { })
    }

    const removeFromChangesAfterSave = () => {
        setChanges({})
        setDuplicates([])
        setDeletedItems([])
        load().then(() => { }).catch(() => console.log('loading failed'))

    }

    // TODO MAYBE DEPENDS ON FEEDBACK
    const showDatePicker = async () => {
        const result = await Swal.fire({
            title: 'Select a date',
            html: '<input type="date" id="datePicker" class="swal2-input">',
            preConfirm: () => {
                const date = Swal.getPopup().querySelector('#datePicker').value;
                if (!date) {
                    Swal.showValidationMessage('Please select a date');
                }
                return date;
            }
        });

        if (result.isConfirmed) {
            console.log('Selected date:', result.value);
            // Continue with your code here
        }
    };

    const getOfficialSchoolName = (item, itr) => {
        let secondarySchool = '';
        let title = '';
        let branch = '';

        if (item.company === props.company.company)
            title += props.company.description

        branches.map((bItr) => {
            if (item.branch === bItr.value) {
                title += bItr.label
                branch = bItr.label
            }
        })
        switch (branch) {
            case 'PASCAL Secondary School':
                if (item.location === 'LEF' || item.location?.toLowerCase() === 'lefkosia') {
                    title = 'PASCAL Private Secondary School Lefkosia'
                    if (itr?.employmentContext === 'BI' || itr?.employmentContext === 'CEBI')
                        secondarySchool = 'Ιδιωτική Ελληνική Σχολή ΠΑΣΚΑΛ Λευκωσία'
                    else if (itr?.employmentContext === 'CGO' || itr?.employmentContext === 'NCGO') {
                        title = ''
                        secondarySchool = 'Ιδιωτική Ελληνική Σχολή ΠΑΣΚΑΛ Λευκωσία'
                    }
                }
                else if (item.location === 'LEM' || item.location?.toLowerCase() === 'lemesos') {
                    title = 'PASCAL Private Secondary School Lemesos'
                    if (itr?.employmentContext === 'BI' || itr?.employmentContext === 'CEBI')
                        secondarySchool = 'Ιδιωτική Ελληνική Σχολή ΠΑΣΚΑΛ Λεμεσός'
                    else if (itr?.employmentContext === 'CGO' || itr?.employmentContext === 'NCGO') {
                        title = ''
                        secondarySchool = 'Ιδιωτική Ελληνική Σχολή ΠΑΣΚΑΛ Λεμεσός'
                    }
                }
                else if (item.location === 'LAR' || item.location?.toLowerCase() === 'larnaka') {
                    title = 'PASCAL Private Secondary School Larnaka'
                }
                break;
            case 'PASCAL Kindergarten School City Centre':
                title = 'PASCAL Private Kindergarten & Primary Lemesos School City Centre'
                break;
            case 'PASCAL Primary School City Centre':
                title = 'PASCAL Private Kindergarten & Primary Lemesos School City Centre'
                break;
            case 'PASCAL Primary School':
                if (item.location === 'LEF' || item.location?.toLowerCase() === 'lefkosia') {
                    title = 'PASCAL Private Kindergarten & Primary School Lefkosia'
                }
                else if (item.location === 'LEM' || item.location?.toLowerCase() === 'lemesos') {
                    title = 'PASCAL Private Kindergarten & Primary School Lemesos'
                }
                else if (item.location === 'LAR' || item.location?.toLowerCase() === 'larnaka') {
                    title = 'PASCAL Private Kindergarten & Primary School Larnaka'
                }
                break;
            case 'PASCAL Kindergarten School':
                if (item.location === 'LEF' || item.location?.toLowerCase() === 'lefkosia') {
                    title = 'PASCAL Private Kindergarten & Primary School Lefkosia'
                }
                else if (item.location === 'LEM' || item.location?.toLowerCase() === 'lemesos') {
                    title = 'PASCAL Private Kindergarten & Primary School Lemesos'
                }
                else if (item.location === 'LAR' || item.location?.toLowerCase() === 'larnaka') {
                    title = 'PASCAL Private Kindergarten & Primary School Larnaca'
                }
                break;
            default:
                console.log("Value is out of range");
        }
        return { secondarySchool: secondarySchool, title: title, branch: branch };
    }

    // * Download excel for results 
    const downloadTimeSheetExcel = async (item, branches) => {
        let title = '';
        let branch = '';


        let schoolYearStart = `01/09/${item.yr - 1}`;
        let schoolYearEnd = `30/06/${item.yr}`;
        let excelTP = [];
        const obj = (props.approvers).find(app => app.value === item.approverID);
        const approverName = obj ? obj.label : undefined;

        getAdditionalPeriodsWithTotals().then((addResp) => {
            loadTeacherperiods(item.timesheetUI)
                .then(tp => {
                    // * Create the list of employees with both morning and afternoon columns 
                    tp.map((itr) => {
                        const emplExists = excelTP.find(employees => employees.emplId === itr.employeeID);
                        if (!emplExists) {
                            let secondarySchool = '';
                            // * For continue employement year ends on Aug

                            if (itr.employmentContext === 'CE' || itr.employmentContext === 'CEBI' || itr.employmentContext === 'CGO')
                                schoolYearEnd = `31/08/${item.yr}`;
                            else
                                schoolYearEnd = `30/06/${item.yr}`;

                            ({ secondarySchool, title, branch } = getOfficialSchoolName(item, itr));
                            let obj = {
                                emplId: itr.employeeID,
                                employeeNum: itr.emplNumber,
                                emplPassport: itr.passNumber,
                                emplContext: itr.employmentContext,
                                emplJobTitle: itr.jobTitle,
                                emplSeniority: itr.seniority,
                                employeeName: itr.name,
                                additionalTotalAM: 0,
                                additionalTotalPM: 0,
                                additionalDesc: getDescriptionByCode(addResp, itr.additionalCode),
                                year: schoolYearStart + ' - ' + schoolYearEnd,
                                morningPeriodsTotals: 0,
                                afternoonPeriodsTotals: 0,
                                approverName: approverName,
                                secondarySchool: secondarySchool,
                                min: branch.includes('Secondary') ? 45 : 40
                            }
                            excelTP.push(obj)
                        }
                    })
                    // * Loop again to add the totals 
                    tp.map((itr) => {
                        const index = excelTP.findIndex(employees => employees.emplId === itr.employeeID);
                        let obj = {}
                        // * Per pascal request Vanessa At the end of the process, an additional box needs to be added that automatically will calculate the average of the teaching periods across all months. This average will be divided by 10 months (the period from September to June).
                        let totalhours = itr.mAverage != 0 ? itr.mAverage : (itr.m1 + itr.m2 + itr.m3 + itr.m4 + itr.m5 + itr.m6 + itr.m7 + itr.m8 + itr.m9 + itr.m10 + itr.m11 + itr.m12) / 10
                        // * For Secondary school convert time periods to 40 minute periods to 45 minutes with formula provided
                        // * by Vanessa Tsestou from Pascal.
                        if (branch.includes('Secondary')) {
                            let convert45min = (totalhours * 40) / 45;
                            totalhours = parseFloat(convert45min.toFixed(1));
                        }
                        totalhours = Math.round(totalhours)
                        let aPeriods = getLabelByValue(addResp, itr.additionalCode);
                        if (itr.ptshdt === 'AM') {
                            obj = {
                                emplId: itr.employeeID,
                                employeeNum: itr.emplNumber,
                                emplPassport: itr.passNumber ?? '',
                                emplContext: itr.employmentContext,
                                emplResPermitNumber: itr.residencePermitNumber ?? '',
                                emplJobTitle: itr.jobTitle,
                                emplSeniority: itr.seniority,
                                employeeName: itr.name,
                                additionalTotalAM: aPeriods,
                                additionalTotalPM: excelTP[index].additionalTotalPM,
                                year: excelTP[index].year,
                                morningPeriodsTotals: totalhours,
                                afternoonPeriodsTotals: excelTP[index].afternoonPeriodsTotals,
                                cardIdentifier: !itr.residencePermitNumber ? !itr.passNumber ? 'Identity Card No.' : 'Passport No.' : 'Residence Permit No.'
                            }
                        }
                        else {
                            obj = {
                                emplId: itr.employeeID,
                                employeeNum: itr.emplNumber,
                                emplPassport: itr.passNumber,
                                emplContext: itr.employmentContext,
                                emplResPermitNumber: itr.residencePermitNumber ?? '',
                                emplJobTitle: itr.jobTitle,
                                emplSeniority: itr.seniority,
                                employeeName: itr.name,
                                additionalTotalAM: excelTP[index].additionalTotalAM,
                                additionalTotalPM: aPeriods,
                                year: excelTP[index].year,
                                morningPeriodsTotals: excelTP[index].morningPeriodsTotals,
                                afternoonPeriodsTotals: totalhours,
                                cardIdentifier: !itr.residencePermitNumber ? !itr.passNumber ? 'Identity Card No.' : 'Passport No.' : 'Residence Permit No.'
                            }
                        }

                        if (index !== -1) {
                            excelTP[index] = { ...excelTP[index], ...obj };
                        }
                    })
                    // console.log(excelTP)
                    exportToWord(excelTP, title, branch);
                })
                .catch(error => {
                    console.error(error)
                });
        })
    }

    // * Validator 
    // TODO Can be abstracted as well probably -- But column names matter ? 
    const validateInput = () => {
        let primarytDate = new Set();
        let ret = [true, t('common:validationSuccess')]
        timesheets.forEach((itr) => {
            // * Check empty description
            if (itr.name === '')
                ret = [false, t('common:nameEmpty')]
            else if (itr.approverID === '')
                ret = [false, t('common:approverEmpty')]
            else if (itr.branch === '')
                ret = [false, t('common:branchEmpty')]
            else if (itr.location === '')
                ret = [false, t('common:locationEmpty')]
        })

        return (ret)
    }

    const toggleApproved = () => {
        setShowApproved(!showApproved)
    }

    //#region SaveDeleteCancel
    const handleSave = async () => {
        let newPromises = [];
        let deleteSucc = false;
        let updateSucc = false;
        let valid = true;

        // * Do not save if Changes table is empty
        if (Object.entries(changes).length == 0 && deletedItems.length == 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "danger",
                duration: 3000,
            })
            return
        }

        // * Check that there is only 1 entry without tdate which indicates the most recent Salary Scheme 
        // * Also check that the date is later than all the other from dates. 
        // ! We do not currently need to check if tdate < fdate because the calendar does not allow you to mkae that selection :)
        let valRet = validateInput();
        if (!valRet[0]) {
            showMessage({
                message: valRet[1],
                type: "danger",
                duration: 3000,
            })
            return;
        }

        //* Attribute definition of values that can be the same in salary schemes 
        const attributesToIgnore = ["timesheetUI", "approved", "submitted", "approverID", "comments", "company", "branch", "location", "childCount", 'yr'];

        // * Check for duplicates,
        // * The loop from the one row is to avoid typing all the object attributes. 
        //! Pascal does want duplicates
        // if (timesheets.length > 0)
        //     Object.keys(timesheets[0]).forEach(key => {
        //         //* Ignore Keys that we know can be duplicated 
        //         if (!attributesToIgnore.includes(key)) {
        //             if (hasDuplicates(timesheets, key, setDuplicates)) {
        //                 showMessage({
        //                     message: t('common:duplicates'),
        //                     type: "danger",
        //                     duration: 3000,
        //                 })
        //                 // * Abort Save if this is triggered.
        //                 valid = false;
        //             }
        //         }
        //     });

        if (!valid)
            return null;

        // TODO Check for dates descending  - TBH I do not see the reason of doing this currently. 
        // console.log(checkDatesDescending())

        //#region Create Promise
        if (Object.entries(changes).length > 0) {
            newPromises.push(
                saveTimesheets(changes)
                    .then((res) => {
                        if (res) {
                            updateSucc = res;
                            removeFromChangesAfterSave();
                        }

                    })
                    .catch(() => { }))
        }
        // * if no changes set updatedSucc to true becuase it might have deleted files to show accurate message
        else {
            updateSucc = true;
        }

        if (deletedItems.length > 0) {
            newPromises.push(deleteTimesheets(deletedItems)
                .then((res) => {
                    if (res) {
                        deleteSucc = res
                        removeFromChangesAfterSave();
                    }
                }).catch(() => { }))
        }
        // * if no changes set deleteSucc to true becuase it might have updated files to show accurate message
        else {
            deleteSucc = true;
        }

        //#endregion

        // * Send the Changes table in the API which only includes Updated or new Lines
        // * No check in the API if row changed. 
        try {
            await Promise.all(newPromises).then(() => {
                if (!updateSucc || !deleteSucc) {
                    if (!deleteSucc) {
                        showMessage({
                            message: t('common:deleteFailed'),
                            type: "danger",
                            duration: 3000,
                        })
                    }
                    else
                        showMessage({
                            message: t('common:issueMessage'),
                            type: "error",
                            duration: 3000,
                        })

                }
                else if (deleteSucc || updateSucc) {
                    showMessage({
                        message: t('common:allOperationsSuccMess'),
                        type: "success",
                        duration: 3000,
                    })
                    setRefreshAfterSave(true);
                }
            });
        } catch (error) {
            console.log(error)
            setRefreshAfterSave(true);
        }
    }
    const handleDelete = (item, index, attribute) => {
        rowDelete(item, index, attribute, changes, setChanges, timesheets, setTimeSheets, setDeletedItems, ref)
    }

    //#endregion
    //#endregion

    //#region Components
    const renderData = useCallback((item, index, itemCount) => {
        if (filterYear !== '' && item.yr !== '') {
            if (filterYear != item.yr)
                return;
        }
        if (item.approved && !showApproved)
            return;
        // * Approval Tab is the same but if logged in account is not approverID from item show nothing. Also item MUST be SUBMITTED
        if (props.isApproval && (account.employeeId !== item.approverID || !item.submitted))
            return
        if (showEmployeePeriods)
            return renderPressableChildren(item, index);
        return (
            <Card
                style={[common.cardstyle]} >
                <Card.Content>
                    <FlatListView
                        item={item} index={index}
                        props={props}
                        styles={styles}
                        handleEditPress={handleEditPress}
                        duplicates={duplicates}
                        years={years}
                        handleDelete={handleDelete}
                        handlePress={handlePress}
                        showChildren={showEmployeePeriods}
                        getLimitedLocationData={getLimitedLocationData}
                        toggleSubmit={toggleSubmit}
                        toggleApprove={toggleApprove}
                        downloadTimeSheetExcel={downloadTimeSheetExcel}
                        t={t}
                        itemCount={itemCount}
                        branches={branches}
                        colors={colors}
                    />
                </Card.Content>
            </Card >
        )
    }, [timesheets, selectedItem, showEmployeePeriods, duplicates, showApproved, filterYear, branches]);

    const renderPressableChildren = (item, index) => {
        if (hasUnsavedChanges)
            return (
                <View>
                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                // * Note: below styles do not seem to be working. Maybe investigate?
                                Swal.fire({
                                    title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:changeBranchesMessage')}</text>`,
                                    icon: "warning",
                                    showCancelButton: true,
                                    reverseButtons: true,
                                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
                                    cancelButtonColor: '#d3d3d3',
                                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
                                    confirmButtonColor: '#A0A2FF',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        setHasUnsavedChanges(false);
                                        handlePress(item, index);
                                    };
                                });
                            }
                        }}>

                        <Card
                            style={[common.cardstyle, buttonStates[index] === true ? styles.Button_SELECTED : null]} >
                            <Card.Content>
                                <FlatListView
                                    item={item} index={index}
                                    props={props}
                                    styles={styles}
                                    handleEditPress={handleEditPress}
                                    duplicates={duplicates}
                                    years={years}
                                    handleDelete={handleDelete}
                                    handlePress={handlePress}
                                    showChildren={showEmployeePeriods}
                                    t={t} />
                            </Card.Content>
                        </Card>
                    </TouchableOpacity>
                </View >
            )
        else return (
            <Pressable onPress={() => { handlePress(item, index) }}>
                <Card
                    style={[common.cardstyle, buttonStates[index] === true ? styles.Button_SELECTED : null]} >
                    <Card.Content>
                        <FlatListView
                            item={item} index={index}
                            props={props}
                            styles={styles}
                            handleEditPress={handleEditPress}
                            duplicates={duplicates}
                            years={years}
                            handleDelete={handleDelete}
                            handlePress={handlePress}
                            showChildren={showEmployeePeriods}
                            t={t} />
                    </Card.Content>
                </Card>
            </Pressable>
        )
    };

    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            {showEmployeePeriods &&
                <TouchableOpacity onPress={() => { handleGoBack() }} style={styles.backButton}>
                    <Ionicons name="arrow-back" size={30} color="black" />
                </TouchableOpacity>
            }
            <SafeAreaView style={[styles.subMain]}>
                {!showEmployeePeriods && !props.isApproval &&
                    <View style={[styles.buttons, styles.functionalityButtons]}>
                        <CustomButton
                            text={t('common:new')}
                            onPress={() => { rowAdd(timesheets, setTimeSheets, ['timesheetUI', 'yr', 'approved', 'submitted', "childCount"], ['approved', 'submitted'], ref, t, ['company'], [], changes, setChanges) }}
                            type='BUTTON_ADD'
                            textTop='0'
                            sz={15}
                        />
                        {(Object.keys(changes).length > 0 || deletedItems.length > 0) &&
                            <CustomButton
                                text={t('common:saveChanges')}
                                onPress={() => handleSave()}
                                type='BUTTON_SAVE'
                                isGradient={true}
                                textTop='0'
                                sz={15}
                            />
                        }
                        <CustomButton
                            text={t('common:cancel')}
                            onPress={() => { handleCancelChanges(setTimeSheets, originalData, setDeletedItems, setChanges, setDuplicates) }}
                            type="BUTTON_CANCEL"
                            sz={15}
                        />
                    </View>
                }
                <View style={styles.row}>
                    <FlatList
                        style={styles.fullHeight}
                        data={timesheets}
                        keyExtractor={(item, index) => `${item.location}-${index}`}
                        renderItem={({ item, index }) =>
                            renderData(item, index, timesheets.length)
                        }
                        scrollEnabled={true}
                        refreshing={isLoading}
                        ref={ref}
                        initialNumToRender={4}
                        ListHeaderComponent={
                            <SafeAreaView style={common.listTitle}>
                                {showEmployeePeriods || props.isApproval ? <></> :
                                    <>
                                        <SafeAreaView
                                            style={styles.rowMargin}>
                                            {/* <SafeAreaView
                                                style={styles.rowMargin}>
                                                
                                                <View style={styles.split} />
                                                <Switch
                                                    value={showApproved ? true : false}
                                                    trackColor={showApproved ? colors.buttons_primary : colors.buttons_primary}
                                                    thumbColor={showApproved ? colors.buttons_primary : colors.buttons_primary}
                                                    onValueChange={() => toggleApproved()}
                                                    name="allowMultipleAnswers" />
                                            </SafeAreaView> */}
                                            <CustomDropDown
                                                defValue={filterYear}
                                                options={years}
                                                value={filterYear}
                                                setValue={setFilterYear}
                                                type='TIMESHEET'
                                            />
                                        </SafeAreaView>
                                        <SafeAreaView
                                            style={styles.rowMargin}>
                                            <SafeAreaView
                                                style={styles.marginLeft} />
                                            <CustomLabel
                                                value={t('common:timesheetName')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:approver')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:branches')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:location')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={t('common:year')}
                                                type='SUBTITLE' />
                                            <CustomLabel
                                                value={''}
                                                type='SUBTITLE' />
                                        </SafeAreaView>
                                        <SafeAreaView style={common.divider} />
                                    </>
                                }

                            </SafeAreaView>

                        }
                        ListEmptyComponent={
                            isLoading ?
                                <ActivityIndicator animating={true} color={colors.blue} />
                                :
                                <CustomLabel
                                    value={t("common:locationsLoadingPreview")}
                                    type="NO_BRANCHES"
                                />
                        }
                    />
                    {
                        showEmployeePeriods ?
                            <SafeAreaView style={styles.childView}>
                                <TeacherPeriods
                                    selectedItem={selectedItem}
                                    toggleSubmit={toggleSubmit}
                                    selectedLocation={selectedLocation}
                                    getOfficialSchoolName={getOfficialSchoolName}
                                    branch={selectedBranch}
                                    location={selectedLocation}
                                />
                            </SafeAreaView>
                            : <></>
                    }
                </View>

            </SafeAreaView >
        </SafeAreaView >
    )
};

//#region Styles
const makeStyles = (colors, width) => StyleSheet.create({
    mainView: {
        flex: 1,
    },
    subMain: {
        marginHorizontal: 15,
        flex: 1,
    },
    justMargin: {
        marginHorizontal: 10,
    },
    marginLeft: {
        marginLeft: 40,
    },
    column: {
        flex: 1,
    },
    columnCheck: {
        alignItems: 'center'
    },
    row: {
        flex: 1,
        margin: 10,
        flexDirection: "row",
        alignItems: 'center',
    },
    backButton: {
        alignSelf: 'flex-end'
    },
    rowNoflex: {
        flexDirection: 'row',
    },
    item: {
        flex: 1,
    },
    functionalityButtons: {
        justifyContent: 'flex-end',
    },
    innerView: {
        flex: 1,
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '50%',
        alignSelf: 'flex-end',
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '4%'
    },
    verticalLine: {
        margin: 5,
        backgroundColor: colors.buttons_primary,
        height: '100%',
        width: 1,
    },
    childView: {
        width: '85%',
        height: '100%'
    },
    listView: {
        flexDirection: 'row',
        height: '100%'
    },
    fullHeight: {
        height: '100%'
    },
    cardStyleBranch: {
        margin: 10,
        borderRadius: 5,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
    Button_SELECTED: {
        margin: 10,
        borderRadius: 5,
        borderWidth: 2,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
        borderColor: colors.buttons_submit,
    },
    rowMargin: {
        flexDirection: "row",
        justifyContent: 'flex-end',
        marginRight: 15,
    },
    split: {
        margin: 5,
    },
});


//#endregion
export default TeacherTimeSheets;